import React from 'react';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { HeroSection } from './training/HeroSection';
import { CalendarSection } from './training/CalendarSection';
import { HostingAndClassesSection } from './training/HostingAndClassesSection';
import { RegistrationSection } from './training/RegistrationSection';
export function TrainingPage() {
  return <div className="min-h-screen flex flex-col bg-brand-black" data-id="element-949">
      <Navbar data-id="element-950" />
      <main className="flex-grow pt-[7.25rem]" data-id="element-951">
        <HeroSection data-id="element-952" />
        <CalendarSection data-id="element-953" />
        <HostingAndClassesSection data-id="element-954" />
        <RegistrationSection data-id="element-955" />
      </main>
      <Footer data-id="element-956" />
    </div>;
}